import { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { setAccessToken, clearAccessToken } from '../helpers/tokenStore';

/**
 * Component that syncs Okta authState.accessToken.accessToken to the token store
 * This allows axios interceptors to access the token
 * Should be rendered inside the Security provider
 */
function AuthTokenSync() {
  const { authState } = useOktaAuth();

  useEffect(() => {
    if (authState?.isAuthenticated && authState?.accessToken?.accessToken) {
      // Update token store with current access token
      setAccessToken(authState.accessToken.accessToken);
    } else {
      // Clear token if not authenticated
      clearAccessToken();
    }
  }, [authState?.isAuthenticated, authState?.accessToken?.accessToken]);

  // This component doesn't render anything
  return null;
}

export default AuthTokenSync;
